import PropTypes from 'prop-types';
import React from 'react';
import Markdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import { SCButton } from 'rollup-allspark';
import { cn, isEmpty } from '../../../utils';
import Code from '../Response/Code';
import CustomLink from '../Response/CustomLink';

const markdownComponents = { a: CustomLink, code: Code };

const Message = ({ message, onRetry }) => {
  const { role, content, streaming, error } = message;

  if (role === 'user') {
    return (
      <div className="flex justify-end">
        <div className="max-w-[85%] whitespace-pre-line rounded-lg rounded-br-sm border border-grey bg-grey px-3 py-2 text-sm leading-5">
          {content}
        </div>
      </div>
    );
  }

  const isThinking = streaming && isEmpty(content);

  return (
    <div className="flex justify-start">
      <div
        className={cn(
          'kai-response-markdown max-w-[92%] rounded-lg rounded-bl-sm border px-3 py-2 text-sm leading-5',
          {
            'border-red-lighter bg-red-lighter': error,
            'border-primary-lighter bg-white': !error,
          },
        )}
      >
        {isThinking ? (
          <div className="flex items-center gap-x-1 py-1 text-grey-darker">
            <span className="kai-typing-dot" />
            <span className="kai-typing-dot" />
            <span className="kai-typing-dot" />
          </div>
        ) : (
          <Markdown
            components={markdownComponents}
            remarkPlugins={[remarkBreaks, remarkGfm]}
            skipHtml
          >
            {content}
          </Markdown>
        )}

        {error && (
          <div className="mt-2 flex items-center justify-between gap-x-2 border-t border-red-lighter pt-2">
            <span className="text-xs text-red-dark">
              Couldn&apos;t finish that answer.
            </span>
            <SCButton
              size="sm"
              variant="danger-outline"
              label="Retry"
              action={onRetry}
            />
          </div>
        )}
      </div>
    </div>
  );
};

Message.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    role: PropTypes.oneOf(['user', 'assistant']),
    content: PropTypes.string,
    streaming: PropTypes.bool,
    error: PropTypes.bool,
  }).isRequired,
  onRetry: PropTypes.func,
};

export default Message;
